import { batch, computed, signal } from "@preact/signals-react"
import {
	acriss,
	bookingRange,
	categories,
	currency,
	dailyPrice,
	dateRange,
	fuelPolicy,
	groupBy,
	insurance,
	inTerminal,
	isLoadingCommonFilters,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	officeGroup,
	offices,
	officesPickoff,
	prepaid,
	providers,
	showFeatures,
	siteGroup,
	sites,
	tiers,
	transmission,
	webSuppliers
} from "@signals"
import { formatDate, stringToDate } from "@ui-seeker/utils"
import { TABLE_OPTION, GROUPING_METHOD } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@constants"
import { validDateOrEmpty } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@services/dates"

export const tableOption = signal(TABLE_OPTION.MIN)
export const leadingOpenUrlModal = signal(null)
export const leadingUrlId = signal(null)
export const leadingUrlOptions = signal([])
export const tableData = signal({
	min: [],
	max: [],
	avg: [],
	xList: [],
	empty: true,
})

//functions
export const resetLeadingFilters = () => batch(() => {
	isLoadingCommonFilters.value = false
	tableOption.value = TABLE_OPTION.MIN
	tableData.value = {
		min: [],
		max: [],
		avg: [],
		xList: [],
		empty: true,
	}
	sites.value = []
	mainSite.value = null
	offices.value = []
	officesPickoff.value = null
	dateRange.value = [new Date(), new Date()]
	bookingRange.value = [new Date(), new Date()]
	lengthRental.value = []
	currency.value = null
	tiers.value = null
	providers.value = []
	webSuppliers.value = []
	categories.value = []
	acriss.value = []
	showFeatures.value = false
	mileage.value = null
	insurance.value = null
	prepaid.value = null
	fuelPolicy.value = null
	transmission.value = null
	inTerminal.value = null
	groupBy.value = GROUPING_METHOD.DAILY
	leadingUrlId.value = null
	leadingOpenUrlModal.value = null
})

export const setFormData = info => batch(() => {
	mainSite.value = info.siteMainID
	mainProvider.value = info.providerMainID
	sites.value = info.siteID
	siteGroup.value = info.siteGroupID
	offices.value = info.officePickupID
	officeGroup.value = info.officeGroupID
	officesPickoff.value = info.officeDropoffID
	dateRange.value = [stringToDate(info.startPickupDate), stringToDate(info.endPickupDate)]
	bookingRange.value = [stringToDate(info.startBookingDate), stringToDate(info.endBookingDate)]
	lengthRental.value = info.lor
	currency.value = info.currency
	tiers.value = info.tiers
	providers.value = info.providerID
	webSuppliers.value = info.webSupplierID
	categories.value = info.categoryID
	acriss.value = info.acriss
	showFeatures.value = info.showFeatures
	mileage.value = info.unlimited_km
	insurance.value = info.insurance
	prepaid.value = info.is_prepaid
	fuelPolicy.value = info.fuelPolicyID
	transmission.value = info.automatic
	inTerminal.value = info.in_terminal_pickup
	groupBy.value = info.groupBy
	dailyPrice.value = info.isDailyPrice
	leadingUrlId.value = info.urlId
})

//computed
export const formData = computed(() => ({
	siteMainID: mainSite.value,
	providerMainID: Array.isArray(mainProvider.value) ? null : mainProvider.value,
	siteID: sites.value,
	siteGroupID: siteGroup.value,
	officePickupID: offices.value,
	officeGroupID: officeGroup.value,
	officeDropoffID: officesPickoff.value,
	startPickupDate: formatDate(validDateOrEmpty(dateRange.value[0]), { format: "yyyyMMdd" }),
	endPickupDate: formatDate(validDateOrEmpty(dateRange.value[1]), { format: "yyyyMMdd" }),
	startBookingDate: formatDate(validDateOrEmpty(bookingRange.value[0]), { format: "yyyyMMdd" }),
	endBookingDate: formatDate(validDateOrEmpty(bookingRange.value[1]), { format: "yyyyMMdd" }),
	lor: lengthRental.value,
	currency: currency.value,
	tiers: tiers.value,
	providerID: providers.value,
	webSupplierID: webSuppliers.value,
	categoryID: categories.value,
	acriss: acriss.value,
	showFeatures: showFeatures.value,
	unlimited_km: mileage.value,
	insurance: insurance.value,
	is_prepaid: prepaid.value,
	fuelPolicyID: fuelPolicy.value,
	automatic: transmission.value,
	in_terminal_pickup: inTerminal.value,
	groupBy: groupBy.value,
	isDailyPrice: dailyPrice.value,
	isNewVersion: true,
	reportType: "leading-price",
	urlId: leadingUrlId.value,
}))